import { RANKS } from './ranks';

// ─── S1 Achievement System ───
export const STAT_MILESTONES = [1, 5, 10, 25, 50, 100, 250, 500, 1000];
export const TASK_MILESTONES = [10, 50, 100, 250, 500, 1000, 2500, 5000, 10000];
export const STAT_TOKEN_REWARDS = [1, 2, 5, 10, 25, 50, 100, 200, 500];

// Rank achievements — only Diamond+ pay rewards
export const RANK_CREWMATE_REWARDS = [0, 0, 0, 0, 0, 0, 5, 15, 40, 100];
export const RANK_IMPOSTOR_REWARDS = [0, 0, 0, 0, 0, 0, 2, 5, 10, 25];

// ─── S2 Achievement System (per-category scaling) ───
// Tasks Completed → crewmate tokens (7.2/game avg)
export const S2_TASK_MILESTONES = [10, 50, 100, 250, 500, 1000, 2500, 5000, 10000];
export const S2_TASK_REWARDS = [1, 2, 3, 5, 8, 12, 20, 30, 50];

// Games Played → crewmate tokens
export const S2_GAMES_MILESTONES = [1, 10, 25, 50, 100, 250, 500, 1000];
export const S2_GAMES_REWARDS = [1, 2, 3, 5, 10, 20, 35, 60];

// Crewmate Wins → crewmate tokens (64%/game)
export const S2_CREW_WINS_MILESTONES = [1, 5, 10, 25, 50, 100, 250, 500, 1000];
export const S2_CREW_WINS_REWARDS = [1, 2, 3, 5, 10, 15, 25, 40, 75];

// Kills → impostor tokens (0.5/game)
export const S2_KILLS_MILESTONES = [1, 5, 10, 25, 50, 100, 250, 500, 1000];
export const S2_KILLS_REWARDS = [1, 3, 5, 10, 15, 25, 40, 60, 100];

// Impostor Wins → impostor tokens (4%/game, hardest)
export const S2_IMP_WINS_MILESTONES = [1, 5, 10, 25, 50, 100, 250, 500, 1000];
export const S2_IMP_WINS_REWARDS = [3, 8, 15, 30, 50, 80, 120, 175, 250];

// S1 categories (existing)
export const ACHIEVEMENT_CATEGORIES = {
  crewmate_games: {
    label: 'Games as Crewmate',
    icon: '🔵',
    tokenType: 'crewmate',
    milestones: STAT_MILESTONES,
    rewards: STAT_TOKEN_REWARDS,
    statField: 'crewmateGames',
  },
  impostor_games: {
    label: 'Games as Impostor',
    icon: '🔴',
    tokenType: 'impostor',
    milestones: STAT_MILESTONES,
    rewards: STAT_TOKEN_REWARDS,
    statField: 'imposterGames',
  },
  kills: {
    label: 'Kills',
    icon: '🗡️',
    tokenType: 'impostor',
    milestones: STAT_MILESTONES,
    rewards: STAT_TOKEN_REWARDS,
    statField: 'kills',
  },
  tasks_completed: {
    label: 'Tasks Completed',
    icon: '✅',
    tokenType: 'crewmate',
    milestones: TASK_MILESTONES,
    rewards: STAT_TOKEN_REWARDS,
    statField: 'tasksCompleted',
  },
  crewmate_rank: {
    label: 'Crewmate Rank',
    icon: '🔵',
    tokenType: 'crewmate',
    type: 'rank',
    milestones: RANKS.map(r => r.name),
    rewards: RANK_CREWMATE_REWARDS,
    eloField: 'highestEloCrewmate',
  },
  impostor_rank: {
    label: 'Impostor Rank',
    icon: '🔴',
    tokenType: 'impostor',
    type: 'rank',
    milestones: RANKS.map(r => r.name),
    rewards: RANK_IMPOSTOR_REWARDS,
    eloField: 'highestEloImposter',
  },
  overall_rank: {
    label: 'Overall Rank',
    icon: '⭐',
    tokenType: 'crewmate',
    type: 'rank',
    milestones: RANKS.map(r => r.name),
    rewards: RANK_CREWMATE_REWARDS,
    eloField: 'highestEloOverall',
  },
};

// S2 categories — 5 stat-based + 3 rank-based
export const ACHIEVEMENT_CATEGORIES_S2 = {
  tasks_completed: {
    label: 'Tasks Completed',
    icon: '✅',
    tokenType: 'crewmate',
    milestones: S2_TASK_MILESTONES,
    rewards: S2_TASK_REWARDS,
    statField: 'tasksCompleted',
  },
  games_played: {
    label: 'Games Played',
    icon: '🎮',
    tokenType: 'crewmate',
    milestones: S2_GAMES_MILESTONES,
    rewards: S2_GAMES_REWARDS,
    statField: 'gamesPlayed',
  },
  crewmate_wins: {
    label: 'Crewmate Wins',
    icon: '🔵',
    tokenType: 'crewmate',
    milestones: S2_CREW_WINS_MILESTONES,
    rewards: S2_CREW_WINS_REWARDS,
    statField: 'crewmateWins',
  },
  kills: {
    label: 'Kills',
    icon: '🗡️',
    tokenType: 'impostor',
    milestones: S2_KILLS_MILESTONES,
    rewards: S2_KILLS_REWARDS,
    statField: 'kills',
  },
  impostor_wins: {
    label: 'Impostor Wins',
    icon: '🔴',
    tokenType: 'impostor',
    milestones: S2_IMP_WINS_MILESTONES,
    rewards: S2_IMP_WINS_REWARDS,
    statField: 'imposterWins',
  },
  crewmate_rank: {
    label: 'Crewmate Rank',
    icon: '🔵',
    tokenType: 'crewmate',
    type: 'rank',
    milestones: RANKS.map(r => r.name),
    rewards: RANK_CREWMATE_REWARDS,
    eloField: 'highestEloCrewmate',
  },
  impostor_rank: {
    label: 'Impostor Rank',
    icon: '🔴',
    tokenType: 'impostor',
    type: 'rank',
    milestones: RANKS.map(r => r.name),
    rewards: RANK_IMPOSTOR_REWARDS,
    eloField: 'highestEloImposter',
  },
  overall_rank: {
    label: 'Overall Rank',
    icon: '⭐',
    tokenType: 'crewmate',
    type: 'rank',
    milestones: RANKS.map(r => r.name),
    rewards: RANK_CREWMATE_REWARDS,
    eloField: 'highestEloOverall',
  },
};

// ─── One-Time Achievements (S2 only) ───
// These are awarded from a single game event, not cumulative stats.
// No token rewards — purely for bragging rights.
export const ONETIME_ACHIEVEMENTS = [
  { id: 'giant_slayer', label: 'Giant Slayer', icon: '⚔️', description: 'Win as impostor with the highest-ELO crewmate in the lobby' },
  { id: 'serial_killer', label: 'Serial Killer', icon: '🔪', description: 'Get 3+ kills in a single game' },
  { id: 'dead_weight', label: 'Dead Weight', icon: '💤', description: 'Win as impostor with 0 kills' },
  { id: 'scapegoat', label: 'Scapegoat', icon: '🐐', description: 'Get voted out as crewmate but your crew still wins' },
  { id: 'from_the_grave', label: 'From the Grave', icon: '⚰️', description: 'Die first but your team still wins' },
  { id: 'carry', label: 'Carry', icon: '💪', description: 'Win as impostor with all the kills (partner got 0)' },
];

// Helper to get the right categories
export function getAchievementCategories() {
  return ACHIEVEMENT_CATEGORIES_S2;
}

/** Build achievement ID from category key and milestone value */
export function getAchievementId(category, milestone) {
  const val = typeof milestone === 'string' ? milestone.toLowerCase().replace(/\s+/g, '_') : milestone;
  return `${category}_${val}`;
}

/** Get rank name for a given ELO value */
export function getRankForElo(elo) {
  let rank = RANKS[0].name;
  for (const r of RANKS) {
    if (elo >= r.min) rank = r.name;
    else break;
  }
  return rank;
}

/** Get rank index for a given ELO value */
export function getRankIndex(elo) {
  let idx = 0;
  for (let i = 0; i < RANKS.length; i++) {
    if (elo >= RANKS[i].min) idx = i;
    else break;
  }
  return idx;
}

/** Get total number of achievements */
export function getTotalAchievements() {
  const cats = ACHIEVEMENT_CATEGORIES_S2;
  let total = Object.values(cats).reduce(
    (sum, cat) => sum + cat.milestones.length, 0
  );
  total += ONETIME_ACHIEVEMENTS.length;
  return total;
}
